
export default [
    {
        path: 'menumanage',
        name: 'menuManage',
        component: () => import(/* webpackChunkName: "uccenter" */ "@/views/menu/index"),
    },
    {
        path: 'rolemanage',
        name: 'roleManage',
        component: () => import(/* webpackChunkName: "uccenter" */ "@/views/role/index"),
    },
    {
        path: 'usermanage',
        name: 'userManage',
        component: () => import(/* webpackChunkName: "uccenter" */ "@/views/user/index"),
    },
    {
        path: 'usermanage/update/:type',
        name: 'userUpdate',
        component: () => import(/* webpackChunkName: "uccenter" */ "@/views/user/update"),
    },
    {
        path: 'registrationmanage',
        name: 'registrationmanage',
        component: () => import(/* webpackChunkName: "uccenter" */ "@/views/registrationmanage/index"),
    },
    {
        path: 'registrationmanage/update/:type',
        name: 'registUpdate',
        component: () => import(/* webpackChunkName: "uccenter" */ "@/views/registrationmanage/update"),

    },
    {
        path: 'orgmanage',
        name: 'orgManage',
        component: () => import(/* webpackChunkName: "uccenter" */ "@/views/org/index"),
    },
    {
        path: 'orgmanage/update/:type',
        name: 'orgUpdate',
        component: () => import(/* webpackChunkName: "uccenter" */ "@/views/org/update"),

    },
    {
        path: 'orgrolemanage',
        name: 'orgroleManage',
        component: () => import(/* webpackChunkName: "uccenter" */ "@/views/orgrole/index"),
    },
    {
        path: 'localemanage',
        name: 'localeManage',
        component: () => import(/* webpackChunkName: "uccenter" */ "@/views/uclocale/index"),
    },
    {
        path: 'accessgroup/index',
        name: 'accessgroup',
        component: () => import(/* webpackChunkName: "uccenter" */ "@/views/accessgroup/index"),
    },
    {
        path: 'announcemanage',
        name: 'announcemanage',
        component: () => import(/* webpackChunkName: "uccenter" */ "@/views/announce/index"),
    },
    {//附件
        path: 'attachment/rule',
        name: 'attachmentrule',
        component: () => import(/* webpackChunkName: "attachment" */ "@/views/attachment/rule/index"),
    },
    {//附件
        path: 'attachmentrule/rule/update/:type',
        name: 'attachmentruleUpdate',
        component: () => import(/* webpackChunkName: "attachment" */ "@/views/attachment/rule/update"),
    },
    {//附件
        path: 'attachment/type',
        name: 'attachmenttype',
        component: () => import(/* webpackChunkName: "attachment" */ "@/views/attachment/type/index"),
    },
    {//附件
        path: 'attachmentrule/type/update/:type',
        name: 'attachmenttypeUpdate',
        component: () => import(/* webpackChunkName: "attachment" */ "@/views/attachment/type/update"),
    },
    {//附件
        path: 'attachment/model',
        name: 'attachmentmodel',
        component: () => import(/* webpackChunkName: "attachment" */ "@/views/attachment/model/index"),
    },
    {//附件
        path: 'attachment/model/update/:type',
        name: 'attachmentmodelUpdate',
        component: () => import(/* webpackChunkName: "attachment" */ "@/views/attachment/model/update"),
    },
    {//附件
        path: 'attachment/file',
        name: 'attachmentfile',
        component: () => import(/* webpackChunkName: "attachment" */ "@/views/attachment/file/index"),
    },
    {//附件
        path: 'attachment/file/update/:type',
        name: 'attachmentfileUpdate',
        component: () => import(/* webpackChunkName: "attachment" */ "@/views/attachment/file/update"),
    },
    {
        path: 'accessgroup/dataReport',
        name: 'accessgroupDataReport',
        component: () => import(/* webpackChunkName: "attachment" */ "@/views/accessgroup/datareport/index"),
    },
    {
        path: 'accessgroup/supplier',
        name: 'accessgroupSupplier',
        component: () => import(/* webpackChunkName: "attachment" */ "@/views/accessgroup/supplier/index"),
    }
];